// Whether the site is accepting orders, set by NEXT_PUBLIC_ORDERS_LIVE in the Secrets tab:
//   unset or "true"                     orders open (form shown, /api/order accepts submissions)
//   "false" (also "0", "off" or "no")   orders closed ("Porositë u mbyllën" card, /api/order rejects)
// The default is OPEN, so a missing or mistyped value never silently closes the site.
// The value is baked in when the site is built, so a change reaches the live site on the next publish.
export const ordersLive = (): boolean => {
    const raw = process.env.NEXT_PUBLIC_ORDERS_LIVE

    if (raw == null || raw.trim() === '') return true

    return !['false', '0', 'off', 'no'].includes(raw.trim().toLowerCase())
}
